<!-- eslint-disable vue/no-v-html -->
<template>
    <BasicCookieCheck :identifyer="'MARKETING'" :reload-required="true">
        <div class="startpage-avatar flex flex-col gap-8">
            <div v-if="config?.avatars && (0 < config?.avatars.length)" class="flex flex-col gap-5">
                <div v-for="avatar in config?.avatars" :key="avatar._id" class="rounded-3xl overflow-hidden shadow">
                    <template v-if="avatar.landscapeVideo?.value">
                        <template v-if="avatar.landscapeVideo?.type == 'avatar'">
                            <StartpageAvatarCloudflare :video="avatar" />
                        </template>
                        <template v-else>
                            <StartpageAvatarYoutube :video="avatar" />
                        </template>
                    </template>
                    <template v-else>
                        <div v-if="avatar.landscape" class="hidden sm:block" v-html="avatar.landscape" />
                        <div v-if="avatar.portrait" class="sm:hidden" v-html="avatar.portrait" />
                    </template>
                </div>
            </div>
        </div>
    </BasicCookieCheck>
</template>
<script lang="ts" setup>
type VideoType = 'short' | 'avatar' | 'video';

interface AvatarVideo {
    type: VideoType;
    value: string;
}
interface Avatar {
    _id: string;
    landscape: string;
    portrait: string;
    title: string;
    validFrom: number;
    validTo: number;
    priorityOverrideFrom: number;
    priorityOverrideTo: number;
    priority: number;
    expiryDate: number;
    ticketId: string;
    week: string;
    comment: string;
    stores: string[];
    createdBy: string;
    createdAt: number;
    landscapeVideo?: AvatarVideo;
    portraitVideo: AvatarVideo;
    modifiedBy: string;
    modifiedAt: number;
}

interface StartpageConfig {
    layout?: string;
    avatars: Avatar[];
}

const config = inject("startpageConfig") as Ref<StartpageConfig> | undefined;
</script>
